import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzzurroTable, SpinnerModule } from 'ngx-zcs-components';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { IonicModule } from '@ionic/angular';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { UpgradeSafetyComponent } from './upgrade-safety.component';

@NgModule({
  declarations: [
    UpgradeSafetyComponent,
  ],
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    SpinnerModule,
  ],
  exports: [
    UpgradeSafetyComponent,
  ],
})
export class UpgradeSafetyModule { }
